import React, {useState} from "react";
import { Box, FormField, Form, Text } from "grommet";
import Modal from "./Modal";
import { useSession } from "next-auth/react";
import { validateEmail } from "../lib/validation";
import Button from "./Button";

const SendCSVModal = ({
    onClose,
    onSubmit
}) => {
    const {data: session} = useSession();
    const [email, setEmail] = useState(session?.user?.email || '')
    return (
        <Modal
            ctaText="Send"
            onClose={onClose}
            title={'Export your invoices to CSV'}
            onSecondaryCtaClicked={onClose}
            hideDeepLink={true}
            containerProps={{width: '500px'}}
            footerProps={{pad: {top: 'xsmall', bottom: 'small'}}}
        >
            <Form
                validate="blur"
                onSubmit={() => {
                    onSubmit && onSubmit(email);
                    onClose && onClose();
                }
                }
            >
                <Box margin={{top: 'xsmall', bottom: "xxsmall"}}>
                    <Text size="medium">
                    Give us a minute to run the export. We'll email you the file as soon as it's ready.
                    </Text>
                </Box>
                <Box gap="small">
                    <Box margin={{top: 'xsmall'}}>
                        <FormField
                            label={'Email address'}
                            name="new_email"
                            validate={validateEmail}
                            placeholder="e.g. ap@acme.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </Box>
                    <Box direction='row' justify='end' gap="small">
                        <Button
                            event={{section: 'send_csv_modal', element: 'cancel'}}  
                            label={(
                                <Box width={{ min: 'xxsmall' }}>
                                    <Text>Cancel</Text>
                                </Box>
                            )}
                            onClick={onClose}
                        />
                        <Button
                            event={{section: 'send_csv_modal', element: 'confirm'}}  
                            primary
                            type='submit'
                            label={(
                                <Box width={{ min: 'xxsmall' }}>
                                    <Text>Confirm</Text>
                                </Box>
                            )}
                        />
                    </Box>
                </Box>
            </Form>
        </Modal>
    );
};

export default SendCSVModal;
